import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';

import EnterpriseMaintenanceContainer   from './EnterpriseMaintenance';
import LicenseMaintenanceContainer   from './LicenseMaintenance';

class Admin extends Component {
  render() {
  	return (
  		<div className="Admin">
        <Switch>
          <Route
            path="/admin/enterprise-maintenance/:context/:enterpriseGUID?/:method?/:primaryGUID?/:submethod?/:secondaryGUID?/:licenseID?"
            render={
                (route) => <EnterpriseMaintenanceContainer
                              context={route.match.params.context}
                              enterpriseGUID={route.match.params.enterpriseGUID}
                              method={route.match.params.method}
                              primaryGUID={route.match.params.primaryGUID}
                              submethod={route.match.params.submethod}
                              secondaryGUID={route.match.params.secondaryGUID}
                              licenseID={route.match.params.licenseID}
                              {...this.props}
                            />
            }
          />
          <Route
            path="/admin/license-maintenance/:method?/:licenseGUID?"
            render={
                (route) => <LicenseMaintenanceContainer
                              method={route.match.params.method}
                              licenseGUID={route.match.params.licenseGUID}
                              {...this.props}
                            />
            }
          />
          <Route render={() => (
            <Redirect to="/" />
          )} />
        </Switch>
      </div>
  	);
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/containers/Admin/Admin.js